import { createFileRoute } from '@tanstack/react-router';

import StoreProductsPage from '@/components/store/products/Page';

export const Route = createFileRoute('/store/products')({
	component: StoreProductsPage,
});
